import { useState } from "react";
import TableCard from "../tableCard/TableCard";

export default function PersonnelReport({ data }) {
  const [header, setHeader] = useState([
    {
      type: "title",
      title: "نام و نام خانوادگی",
      name: "fullname",
    },
    {
      type: "auto",
      title: "تعداد کل عملیاتهای مانیتور شده",
      name: "OperationCount",
    },
    {
      type: "description",
      title: "شاخص عملکرد مفید",
      name: "avgUsefullOperation",
    },
    {
      type: "auto",
      title: "عملکرد مفید روزانه",
      name: "avgUsefulHours",
    },
    {
      type: "auto",
      title: "میانگین حضور روزانه",
      name: "average_attendance_time",
    },
    {
      type: "auto",
      title: "میانگین رشد عملکرد",
      name: "PerformanceGrowth",
    },
    {
      type: "auto",
      title: "رشد عملکرد 3 روزه",
      name: "PerformanceGrowthThreeDay",
    },
    {
      type: "title",
      title: "غیبت این ماه",
      name: "absenceInMonth",
    },
    {
      type: "title",
      title: "مرخصی این ماه",
      name: "leaveInMonth",
    },
  ]);
  const [content, setContent] = useState([]);
  return (
    <div>
      <h5 className="fw-bolder fs-5 me-auto"> گزارش پرسنل</h5>
      {data.map((value) => {
        return (
          <TableCard
            column={header}
            content={value}
            bg={"navy_custom"}
            widthParent={"95%"}
            showSelect="false"
          ></TableCard>
        );
      })}
    </div>
  );
}
